import script from "./ExternalIconWithFallback.vue?vue&type=script&lang=js"
export * from "./ExternalIconWithFallback.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__